'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var retry = require('retry');

var networkErrorMsgs = ['Failed to fetch', // Chrome
'NetworkError when attempting to fetch resource.', // Firefox
'The Internet connection appears to be offline.', // Safari
'Network request failed' // `cross-fetch`
];

var AbortError = /*#__PURE__*/function (_Error) {
  _inherits(AbortError, _Error);

  var _super = _createSuper(AbortError);

  function AbortError(message) {
    var _this;

    _classCallCheck(this, AbortError);

    _this = _super.call(this);

    if (message instanceof Error) {
      _this.originalError = message;
      var _message = message;
      message = _message.message;
    } else {
      _this.originalError = new Error(message);
      _this.originalError.stack = _this.stack;
    }

    _this.name = 'AbortError';
    _this.message = message;
    return _this;
  }

  return AbortError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var decorateErrorWithCounts = function decorateErrorWithCounts(error, attemptNumber, options) {
  // Minus 1 from attemptNumber because the first attempt does not count as a retry
  var retriesLeft = options.retries - (attemptNumber - 1);
  error.attemptNumber = attemptNumber;
  error.retriesLeft = retriesLeft;
  return error;
};

var isNetworkError = function isNetworkError(errorMessage) {
  return networkErrorMsgs.includes(errorMessage);
};

var pRetry = function pRetry(input, options) {
  return new Promise(function (resolve, reject) {
    options = _objectSpread({
      onFailedAttempt: function onFailedAttempt() {},
      retries: 10
    }, options);
    var operation = retry.operation(options);
    operation.attempt( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(attemptNumber) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.t0 = resolve;
                _context.next = 4;
                return input(attemptNumber);

              case 4:
                _context.t1 = _context.sent;
                (0, _context.t0)(_context.t1);
                _context.next = 34;
                break;

              case 8:
                _context.prev = 8;
                _context.t2 = _context["catch"](0);

                if (_context.t2 instanceof Error) {
                  _context.next = 13;
                  break;
                }

                reject(new TypeError("Non-error was thrown: \"".concat(_context.t2, "\". You should only throw errors.")));
                return _context.abrupt("return");

              case 13:
                if (!(_context.t2 instanceof AbortError)) {
                  _context.next = 18;
                  break;
                }

                operation.stop();
                reject(_context.t2.originalError);
                _context.next = 34;
                break;

              case 18:
                if (!(_context.t2 instanceof TypeError && !isNetworkError(_context.t2.message))) {
                  _context.next = 23;
                  break;
                }

                operation.stop();
                reject(_context.t2);
                _context.next = 34;
                break;

              case 23:
                decorateErrorWithCounts(_context.t2, attemptNumber, options);
                _context.prev = 24;
                _context.next = 27;
                return options.onFailedAttempt(_context.t2);

              case 27:
                _context.next = 33;
                break;

              case 29:
                _context.prev = 29;
                _context.t3 = _context["catch"](24);
                reject(_context.t3);
                return _context.abrupt("return");

              case 33:
                if (!operation.retry(_context.t2)) {
                  reject(operation.mainError());
                }

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8], [24, 29]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  });
};

module.exports = pRetry; // TODO: remove this in the next major version

module.exports.default = pRetry;
module.exports.AbortError = AbortError;